// extracted by mini-css-extract-plugin
export var border = "IntroHeroLeftAligned-module--border--05184";
export var bordersection = "IntroHeroLeftAligned-module--bordersection--cc86e";
export var herowithimagecontainer = "IntroHeroLeftAligned-module--herowithimagecontainer--fce81";
export var imagecontainer = "IntroHeroLeftAligned-module--imagecontainer--4acba";
export var subheading = "IntroHeroLeftAligned-module--subheading--3ab72";
export var textcontainer = "IntroHeroLeftAligned-module--textcontainer--04736";
export var title = "IntroHeroLeftAligned-module--title--baa9a";
export var topsectionouter = "IntroHeroLeftAligned-module--topsectionouter--b40ca";